import { PaletteMode } from '@mui/material';

import { defaultColor } from './default';
import { errorColor } from './error';
import { infoColor } from './info';
import { newColor } from './new';
import { successColor } from './success';
import { warningColor } from './warning';

export const status = (mode: PaletteMode) => {
  return {
    default: defaultColor(mode),
    new: newColor(mode),
    info: infoColor(mode),
    success: successColor(mode),
    warning: warningColor(mode),
    error: errorColor(mode),
  };
};
